import { AxiosResponse, isAxiosError } from "axios";

export async function catchAxiosResponseError<Data, ResponseError extends Error>(
    dataPromise: Promise<AxiosResponse<Data>>,
    onError: (errorResponse: unknown, status: number) => ResponseError,
): Promise<Data> {
    try {
        return (await dataPromise).data;
    } catch (error) {
        if (isAxiosError(error) && error.response != null) {
            const { data, status } = error.response;
            if (data != null) {
                throw onError(data, status);
            }
        }

        throw error;
    }
}
